<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="cs-constraint-modal max-modal"
      dialog-width="95vw"
      dialog-height="95vh"
    >
      <template #header>
        {{ ls({ ja: '検索制約の編集', en: 'Edit Search Constraints' }) }}
      </template>
      <div class="jps-modal-content">
        <ValidationForm
          :rule="rule"
          :target="constraintValue"
          only="c,note"
        />
        <SearchBox :ss="ss" :additional=true />
        <UiItemSearchResult v-if="ss.searched" :ss="ss" />
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()" :disabled="!valid">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { testCustomSearch } = useItem()

interface Props {
  editstate?: CsEditState
  constraint?: CustomSearchConstraint
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _editstate: Ref<CsEditState> = ref()
const _constraint: Ref<CustomSearchConstraint> = ref()
const ss: Ref<SearchStore<Item>> = ref(null)
const constraintValue: Ref<CustomSearchConstraint> = ref()
const openAwait = async (options?: Props) => {
  setOptionsValue(_editstate, 'editstate', props, options)
  setOptionsValue(_constraint, 'constraint', props, options)

  let cs = clone(_editstate.value.cs)
  cs.constraints = []
  ss.value = useSearch<Item>(
    cs,
    testCustomSearch(cs),
    {
      configHistory: false,
      configSyncRoute: false,
    }
  )
  ss.value.addAfterSearchListener(r => {
    constraintValue.value.q = clone(ss.value.state.currentQuery)
  })
  if (_constraint.value) {
    constraintValue.value = clone(_constraint.value)
    nextTick(() => {
      console.info('restore query', constraintValue.value.q)
      ss.value.restoreQuery(constraintValue.value.q)
    })
  } else {
    constraintValue.value = {
      note: {},
      c: 'AND',
      q: {},
    }
  }
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

const rule = CUSTOM_SEARCH_CONSTRAINT_RULE

const valid = computed(() => {
  let copy = clone(constraintValue.value.q)
  delete copy.csid
  delete copy.from
  delete copy.size
  delete copy.sort
  return !isEmpty(copy)
})

const confirm = () => {
  delete constraintValue.value.q.csid
  delete constraintValue.value.q.from
  delete constraintValue.value.q.size
  delete constraintValue.value.q.sort
  modal.value.resolve(normalizeEmpty(constraintValue.value))
}
</script>

<style lang="scss" scoped>
.cs-constraint-modal {
  .jps-search-box {
    margin-top: 1.5rem;
  }
}
</style>
